import React from 'react';
import {Link} from 'react-router-dom';

type LinkButtonProps = {
  to: string;
  className?: string;
  children: React.ReactNode;
};

function LinkButton({to, className, children}: LinkButtonProps) {
  return (
    <Link to={to} className={`text-dodger-blue leading-10 ${className || ''}`}>
      {children}
    </Link>
  );
}

export default LinkButton;
